import ConsentCheckbox from '@/components/order/order-summary/ConsentCheckbox';
import { formatDateForDisplay } from '@/pages/umeds/order-medication/util';
import { Box, Link, Typography } from '@montugroup/design-system';
import React from 'react';

export interface DispenseIntervalDelayAcceptanceProps {
  isChecked: boolean;
  setIsChecked: (isChecked: boolean) => void;
  delayedUntilDate: string;
}

const dispenseIntervalUrl =
  'https://support.umeds.com.au/hc/en-au/articles/36042289572377-Understanding-prescriptions#h_01JKRZJDK1FG067096Y3C2XHRQ' as const;

export const DispenseIntervalDelayAcceptance = (props: DispenseIntervalDelayAcceptanceProps) => {
  const { isChecked, setIsChecked, delayedUntilDate } = props;

  const formattedDate = formatDateForDisplay(delayedUntilDate);
  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <Box marginTop={3}>
      <ConsentCheckbox
        size="small"
        testid="dispense-limit-consent"
        trackingId="DispenseLimitDelayAcceptance"
        text={
          <>
            I understand that my order will be delayed due to{' '}
            <Link href={dispenseIntervalUrl} target="_blank">
              dispense interval time
            </Link>
            . The order will be processed on or after{' '}
            <Typography variant="body2" sx={{ fontSize: '0.75rem', fontWeight: 500, display: 'inline' }}>
              {formattedDate}
            </Typography>
            .
          </>
        }
        checked={isChecked}
        onChange={handleChange}
      />
    </Box>
  );
};
